import { render, staticRenderFns } from "./life_record.vue?vue&type=template&id=1fd4315a&scoped=true"
import script from "./life_record.vue?vue&type=script&lang=js"
export * from "./life_record.vue?vue&type=script&lang=js"
import style0 from "./life_record.vue?vue&type=style&index=0&id=1fd4315a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4315a",
  null
  
)

export default component.exports